import React, { useState, useContext, useEffect } from "react";
import CajonIzquierda from "./CajonIzquierda";
import { Link, useLocation } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LogoutIcon from '@mui/icons-material/Logout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from "@mui/material/styles";
import { Toolbar, IconButton, Typography, Drawer, AppBar, Box, List, Avatar, Divider, ListItemIcon, Tooltip, Link as MuiLink } from "@mui/material";
import { LogoIcon } from "../../tool";
import { ColorModeContext } from "../../../theme/ThemeProvider";
import { useStateValue } from "../../../contexto/store";
import { alpha } from '@mui/material/styles';
import { useInstitutions } from "../../../hooks/useInstitutions";

const drawerWidth = 260;
const miniDrawerWidth = 70;

const BarSesion = (props) => {
  const { window } = props;
  const theme = useTheme();
  const location = useLocation();
  const [{ sesionUsuario, drawer: drawerState, institution: globalInstitution }, dispatch] = useStateValue();
  const { logout } = useAuth();
  const { toggleTheme, toggleDarkMode, isDarkMode, currentTheme, themeColors } = useContext(ColorModeContext);
  const isCollapsed = drawerState?.isCollapsed || false;

  const { institutions } = useInstitutions();
  const institution = institutions && institutions.length > 0 ? institutions[0] : null;

  useEffect(() => {
    if (institution && (!globalInstitution || globalInstitution.institutionId !== institution.institutionId)) {
      dispatch({ type: "SET_INSTITUTION", value: institution });
    }
  }, [institution, globalInstitution, dispatch]);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleToggleCollapse = () => {
    dispatch({ type: "TOGGLE_DRAWER" });
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const salirSesionApp = () => {
    handleMenuClose();
    logout();
  };

  const currentDrawerWidth = isCollapsed ? miniDrawerWidth : drawerWidth;

  const drawer = (
    <Box sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: 'primary.darker',
      color: 'common.white',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      overflowX: 'hidden'
    }}>
      <Toolbar sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 0,
        m: 0,
        minHeight: 'auto !important'
      }}>
        <Box
          component={Link}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            p: 0,
            m: 0,
            width: '100%',
            justifyContent: 'center',
            transition: 'transform 0.2s',
            '&:hover': { transform: 'scale(1.05)' }
          }}
        >
          {institution?.logo ? (
            <Box
              component="img"
              src={institution.logo}
              alt="Logo"
              sx={{
                width: isCollapsed ? '80%' : '140px',
                height: 'auto',
                maxHeight: isCollapsed ? '60px' : '90px',
                objectFit: 'contain',
                filter: 'brightness(0) invert(1)',
                p: 0,
                m: 0
              }}
            />
          ) : (
            <LogoIcon sx={{ fontSize: isCollapsed ? '2.5rem' : '3.5rem', color: 'common.white', p: 0, m: 0 }} />
          )}
        </Box>
      </Toolbar>
      <Divider sx={{ mb: 2, borderColor: alpha(theme.palette.common.white, 0.15) }} />
      <Box sx={{ flexGrow: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        <List sx={{ px: isCollapsed ? 0.5 : 2 }}>
          <CajonIzquierda />
        </List>
      </Box>
      {!isCollapsed && (
        <Box sx={{ p: 2, mt: 'auto' }}>
          <Typography variant="caption" display="block" align="center" sx={{ color: alpha(theme.palette.common.white, 0.5) }}>
            SoporteBo v2.1.0
          </Typography>
        </Box>
      )}
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  const isDashboardActive = location.pathname === "/dashboard";

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { sm: `calc(100% - ${currentDrawerWidth}px)` },
          ml: { sm: `${currentDrawerWidth}px` },
          bgcolor: 'background.paper',
          borderBottom: `1px solid ${theme.palette.divider}`,
          backdropFilter: 'blur(8px)',
          backgroundColor: alpha(theme.palette.background.paper, 0.9),
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' }, color: 'primary.main' }}
            >
              <MenuIcon />
            </IconButton>

            {/* Collapse Toggle Button for Desktop */}
            <IconButton
              onClick={handleToggleCollapse}
              sx={{
                display: { xs: 'none', sm: 'flex' },
                mr: 2,
                bgcolor: alpha(theme.palette.primary.main, 0.05),
                color: 'primary.main',
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.1) }
              }}
            >
              {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>

            <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 1 }}>

              <MuiLink
                component={Link}
                to="/dashboard"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.8,
                  textDecoration: 'none',
                  color: isDashboardActive ? 'primary.main' : 'text.secondary',
                  fontWeight: isDashboardActive ? 700 : 500,
                  transition: 'all 0.2s',
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 2,
                  bgcolor: isDashboardActive ? alpha(theme.palette.primary.main, 0.08) : 'transparent',
                  '&:hover': {
                    color: 'primary.main',
                    bgcolor: alpha(theme.palette.primary.main, 0.05)
                  }
                }}
              >
                <DashboardIcon fontSize="small" />
                <Typography variant="body1" fontWeight="inherit">
                  Dashboard
                </Typography>
              </MuiLink>
            </Box>

            <Typography variant="h6" noWrap component="div" sx={{ color: 'text.primary', fontWeight: 700, display: { xs: 'block', md: 'none' } }}>
              {institution?.name || "Agua Potable"}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{ textAlign: 'right', display: { xs: 'none', sm: 'block' } }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary', fontWeight: 600 }}>
                {sesionUsuario ? sesionUsuario.usuario.nombreCompleto : "Usuario"}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
                {sesionUsuario?.usuario?.rolName || "Invitado"}
              </Typography>
            </Box>



            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton onClick={toggleDarkMode} color="primary">
                {isDarkMode ? <Brightness7Icon /> : <Brightness4Icon />}
              </IconButton>
            </Box>

            <IconButton
              onClick={handleMenuClick}
              size="small"
              sx={{
                border: `2px solid ${theme.palette.primary.light}`,
                p: 0.5,
                transition: 'all 0.2s',
                '&:hover': { boxShadow: `0 0 0 4px ${alpha(theme.palette.primary.light, 0.3)}` }
              }}
            >
              <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: '1rem' }}>
                {sesionUsuario && sesionUsuario.usuario.nombreCompleto ? sesionUsuario.usuario.nombreCompleto.charAt(0) : 'U'}
              </Avatar>
            </IconButton>
          </Box>

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            onClick={handleMenuClose}
            slotProps={{ paper: {
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
                mt: 1.5,
                width: 200,
                borderRadius: 3,
                border: `1px solid ${theme.palette.divider}`,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                  borderLeft: `1px solid ${theme.palette.divider}`,
                  borderTop: `1px solid ${theme.palette.divider}`,
                },
              },
            } }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <Box sx={{ px: 2, py: 1.5 }}>
              <Typography variant="subtitle2" noWrap>
                {sesionUsuario?.usuario?.nombreCompleto}
              </Typography>
              <Typography variant="caption" color="text.secondary" noWrap>
                {sesionUsuario?.usuario?.email}
              </Typography>
            </Box>
            <Divider />
            <MenuItem component={Link} to="/auth/perfil" sx={{ py: 1.5 }}>
              <ListItemIcon>
                <AccountCircleIcon fontSize="small" />
              </ListItemIcon>
              Perfil
            </MenuItem>
            <MenuItem onClick={salirSesionApp} sx={{ py: 1.5, color: 'error.main' }}>
              <ListItemIcon>
                <LogoutIcon fontSize="small" color="error" />
              </ListItemIcon>
              Cerrar Sesión
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: { sm: currentDrawerWidth },
          flexShrink: { sm: 0 },
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, bgcolor: 'primary.darker', border: 'none' },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: currentDrawerWidth,
              bgcolor: 'primary.darker',
              border: 'none',
              transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
              overflowX: 'hidden'
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  );
};

export default BarSesion;
